import { FileUpload, FileUploadBeforeSendEvent, FileUploadHandlerEvent, FileUploadSelectEvent, FileUploadUploadEvent } from 'primereact/fileupload';
import { getAPIUrl, getWorkspaceEndpoint } from '../helper';

import React from 'react';
import { useAppSelector } from '../hooks';
import { useTranslation } from 'react-i18next';

const SimpleUploader: React.FC<{
    onUpload?:(e: FileUploadUploadEvent) => void,
    onSelect?:(e: FileUploadSelectEvent) => void,
    label?:string,
    url?:string,
    accept?:string,
    maxFileSize?: number,
    uploadHandler?: Function,
    auto?: boolean,
}> = props => {
    const { JWTaccess } = useAppSelector(state => state.authentication)
    const { t } = useTranslation();
    return <FileUpload
        mode="basic"
        name="file"
        url={props.url || `${getAPIUrl()}${getWorkspaceEndpoint('/files/')}`}
        onBeforeSend={(e:FileUploadBeforeSendEvent) => {
            e.xhr.setRequestHeader('authorization', `Bearer ${JWTaccess}`);
        }}
        uploadHandler={(e:FileUploadHandlerEvent) => props?.uploadHandler && props.uploadHandler(e)}
        onSelect={(e:FileUploadSelectEvent) => props?.onSelect && props.onSelect(e)}
        accept={props.accept || "*/*"}
        maxFileSize={props.maxFileSize || 8000000}
        onUpload={props.onUpload}
        auto={props.auto}
        chooseLabel={props.label ? props.label : t('app:send_a_file')}
    />
}

export default SimpleUploader;
